import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"reserve-btn",attrs:{"height":"30","block":"","loading":_vm.loading,"disabled":this.$store.state.call.reserveBtnStatus},on:{"click":function($event){return _vm.selectedCast(_vm.castId, _vm.corporationId)}}},[_c('IconReserve',{staticClass:"reserve-icon",staticStyle:{"fill":"#FFF"}}),_vm._v("ご予約")],1)}
var staticRenderFns = []

export { render, staticRenderFns }